<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  corrections: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const correctionItems = computed(() =>
  [
    {
      key: 'imovel',
      icon: 'i-lucide-house',
      label: t('POST_SALE.TABLE.CORRECTION_ITEMS.PROPERTY'),
    },
    {
      key: 'vendedor',
      icon: 'i-lucide-user-round',
      label: t('POST_SALE.TABLE.CORRECTION_ITEMS.SELLERS'),
    },
    {
      key: 'comprador',
      icon: 'i-lucide-users',
      label: t('POST_SALE.TABLE.CORRECTION_ITEMS.BUYERS'),
    },
    {
      key: 'recibo',
      icon: 'i-lucide-file-text',
      label: t('POST_SALE.TABLE.CORRECTION_ITEMS.RECEIPT'),
    },
  ].map(item => ({ ...item, active: Boolean(props.corrections[item.key]) }))
);
</script>

<template>
  <div
    class="flex items-center gap-2"
    :aria-label="t('POST_SALE.TABLE.CORRECTIONS')"
  >
    <span
      v-for="item in correctionItems"
      :key="item.key"
      class="inline-flex size-6 items-center justify-center"
      :title="item.label"
    >
      <span
        class="size-5"
        :class="[
          item.icon,
          item.active ? 'text-emerald-600' : 'text-lais-text-muted',
        ]"
      />
    </span>
  </div>
</template>
